import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function BlurIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="12"
        height="16"
        viewBox="0 0 12 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 3.1C7.9 5.5 10 8.6 10 10C10 12.8 7.7 14 6 14C4.3 14 2 12.8 2 10C2 8.5 4.1 5.5 6 3.1ZM6 0C6 0 0 6.5 0 10C0 13.8 3.1 16 6 16C8.9 16 12 13.8 12 10C12 6.5 6 0 6 0Z" />
      </svg>
    </Icon>
  );
}
